import React, { createContext, useContext, useState, useMemo } from 'react';

const SettingsContext = createContext(null);

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error('useSettings must be used within SettingsProvider');
  return ctx;
};

export const SettingsProvider = ({ children }) => {
  const [activeSection, setActiveSection] = useState('account');
  const value = useMemo(() => ({ activeSection, setActiveSection }), [activeSection]);
  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
